export const LOCALES = {
    ENGLISH: 'EN',
    FRENCH: 'FR'
  };
  